import { render, staticRenderFns } from "./Expert_management.vue?vue&type=template&id=70d70eae"
import script from "./Expert_management.vue?vue&type=script&lang=js"
export * from "./Expert_management.vue?vue&type=script&lang=js"
import style0 from "./Expert_management.vue?vue&type=style&index=0&id=70d70eae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports